export default __webpack_public_path__ + "static/img/swipegif1.0ad1055.gif";